// src/config/frameworkData.js
// This data will be imported by FrameworkWheel.jsx and HomePage.jsx/FrameworkDetailPanel

export const STEPS = [
  {
    id: 1,
    name: "Clarify",
    subtitle: "Define goals & real-life constraints.",
    icon: "🧭",
    sessionBullets: [
      "Map goals, life transitions, business realities, and cash flow needs.",
    ],
    outcomeBullets: [
      "A clear picture of your current life architecture: people, entities, cash flows.",
      "A short list of 3–5 governing priorities that everything else will answer to.",
      "Agreement on what success looks like 10+ years from now.",
    ],
  },
  {
    id: 2,
    name: "Diagnose",
    subtitle: "Analyze architecture & risk profile.",
    icon: "🔬",
    sessionBullets: [
      "X-ray where risk and concentration actually live: portfolios, business, taxes, guarantees.",
      "Surface hidden frictions: fees, complexity, behavioral triggers, mismatched time horizons.",
      "Stress-test the current setup against a few simple “what if” shocks.",
    ],
    outcomeBullets: [
      "A risk map: where your plan is robust, and where it’s exposed.",
      "A short list of “critical issues” that must be addressed before anything else.",
      "A shared understanding of tradeoffs: where you’re intentionally taking risk, and why.",
    ],
  },
  {
    id: 3,
    name: "Design",
    subtitle: "Build strategies for purpose.",
    icon: "📐",
    sessionBullets: [
      "Translate your priorities into design rules: liquidity, growth, safety, and flexibility.",
      "Decide which “buckets” exist (family, business, legacy, optionalality) and how they talk to each other.",
      "Balance portfolios, entities, and protections around the life you actually want to live.",
    ],
    outcomeBullets: [
      "A draft Wealth Design Blueprint that connects accounts, entities, and goals.",
      "Clear target ranges for cash, risk assets, and “never lose” capital.",
      "A list of implementation steps, ordered by impact and urgency.",
    ],
  },
  {
    id: 4,
    name: "Deploy",
    subtitle: "Execute with discipline.",
    icon: "⚙️",
    sessionBullets: [
      "Turn the design into specific actions: transfers, allocations, account changes, and documents.",
      "Decide what will be automated (savings, rebalancing, distributions) vs. what stays manual and deliberate.",
      "Script behavior ahead of time so decisions in volatile moments are already made.",
    ],
    outcomeBullets: [
      "An implementation checklist with owners and timelines (who does what, and when).",
      "Standing instructions: how cash moves, when rebalancing happens, how we respond to volatility.",
      "Clarity on your communication rhythm with us during and after deployment.",
    ],
  },
  {
    id: 5,
    name: "Review",
    subtitle: "Adapt to life, not noise.",
    icon: "🔄",
    sessionBullets: [
      "Compare what actually happened vs. what we planned for: life events, markets, spending, business.",
      "Decide whether any of the original principles need to change—or if the plan is working as designed.",
      "Re-prioritize: what’s coming in the next 12–24 months that the plan should already be preparing for?",
    ],
    outcomeBullets: [
      "A concise Annual Review Summary: what changed, what we adjusted, what stays the same.",
      "Updated action items (if any) and confirmed guardrails for the year ahead.",
      "Confidence that the plan is alive, monitored, and aligned with your current reality.",
    ],
  },
];
